import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4963b180&scoped=true"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"
import style0 from "./index.vue?vue&type=style&index=0&id=4963b180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4963b180",
  null
  
)

export default component.exports